<template>
  <Modal
    :title="$t('Recommendations.importCatalog')"
    :primary-action="{
      label: $t('Import'),
      onAction: upload,
      disabled: !files.length || isUploading
    }"
    :secondary-actions="[
      {
        label: $t('Cancel'),
        onAction: () => $emit('close')
      }
    ]"
    :visible="visible"
    :loading="isUploading"
  >
    <FileInput
      :label="$t('Recommendations.catalogFile')"
      v-model="files"
      :help-text="$t('Recommendations.importFileHelpText')"
      :max-bytes="50 * 1000 * 1000"
    ></FileInput>
  </Modal>
</template>

<script>

export default {
  props: {
    catalogId: {
      type: Number
    },
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      isUploading: false,
      files: []
    }
  },
  methods: {
    upload() {
      const toast = this.$ui.toast({
        title: this.$t('Recommendations.importCatalog'),
        content: `${this.$t('Recommendations.preparingUpload')}...`,
        loading: true
      })
      this.isUploading = true
      this.api.importCatalog({
        catalogId: this.catalogId,
        file: this.files[0],
        onProgress: ({percent}) => {
          toast.content = `${this.$t('Uploading')}...`
          toast.progress = percent
        }
      })
        .then(() => {
          toast.content = `${this.$t('Recommendations.importStarted')}`
          toast.progress = null
          this.$emit('upload')
        })
        .catch(() => {
          toast.content = `${this.$t('Recommendations.error.importingCatalog')}`
        })
        .finally(() => {
          toast.loading = false
          this.isUploading = false
          this.files = []
        })
    }
  }
}
</script>
